import {qspost} from '@/plugins/axios'

/*
 * 文件列表
 * @constructor jack
 * */
export const companyQuery = (search_name, page, pageSize) => qspost('/api/index/companyQuery', {
  search_name, page, pageSize
})


/*
 * 专职委员会
 * @constructor jack
 * */
export const getCommittee = () => qspost('/api/System/getCommittee', {})

